<template>
    <BreadCrumb PageTitle="Ajouter un emplacement" />
    <AddEmplacement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddEmplacement from "../../components/Emplacement/AddEmplacement.vue";
    export default defineComponent({
      name: "AddEmplacementPage",
      components: {
        BreadCrumb,
        AddEmplacement,
      },
    });
  </script>